module.exports = __webpack_public_path__ + "antwebbuilding.gif?ef33d68baf3bc379225763f1ed351ee0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/antwebbuilding.gif
// module id = 9
// module chunks = 0